export const CONTACT_FOR_UNIT_CONTACT_TYPES = [
    { label: 'メール', value: 1 },
    { label: '電話', value: 2 },
    { label: 'Web会議', value: 3 },
    { label: 'その他', value: 4 },
];
export const CONTACT_FOR_UNIT_IS_ANONYMOUS = 1;
export const CONTACT_FOR_UNIT_IS_NOT_ANONYMOUS = 2;
